import { SectionError, SectionLoading } from '@/components/section-state';
import type { QueryStateProps } from './components.types';

/** Loading/error placeholder for one query; renders nothing once data is ready. */
export const QueryState = ({ isLoading, isError, error, onRetry, loadingLabel, errorTitle }: QueryStateProps) => {
  if (isLoading) return <SectionLoading label={loadingLabel} />;
  if (isError) return <SectionError title={errorTitle} error={error} onRetry={onRetry} />;
  return null;
};
